<template>
    <BaseModal
        :name="props.name"
        :closeOutside="props.closeOutside"
        @close="onCancel"
        class="modal-confirm"
    >
        <template v-slot:content>
            <span class="title">
                {{ confirmSettings?.title || '' }}
            </span>

            <div class="modal-confirm-body">
                <div v-if="confirmSettings?.body" v-html="confirmSettings?.body" class="question"></div>

                <AdditionFields v-if="confirmSettings.additionFields"
                    :fields="confirmSettings.additionFields" ref="additionFields"/>

                <Message :text="confirmSettings.info" type="info"/>
                <Message :text="confirmSettings.success" type="success"/>
                <Message :text="confirmSettings.attention" type="attention"/>

                <ul v-if="confirmSettings.confirmations?.length" class="confirmations">
                    <li v-for="(item, id) in confirmSettings.confirmations"
                        :key="id">

                        <input
                            type="checkbox"
                            :id="`modal-confrim-confirmations-${id}`"
                            v-model="item.checked"
                        />
                        <label :for="`modal-confrim-confirmations-${id}`">{{ item.name }}</label>
                    </li>
                </ul>
            </div>

            <div class="buttons">
                <Button
                    class="size-l"
                    :class="{ secondary: confirmSettings.confirmations?.length || confirmSettings.additionFields?.length }"
                    :name="confirmSettings?.okCancel || t('modals.confirm.cancel')"
                    @click="onCancel"
                />

                <Button v-if="!confirmSettings?.cancelOnly"
                    class="size-l"
                    :class="{ secondary: !confirmSettings.confirmations?.length && !confirmSettings.additionFields?.length }"
                    :name="confirmSettings?.okTitle || t('modals.confirm.ok')"
                    :disabled="confirmSettings.confirmations?.length && confirmSettings.confirmations.some(item => !item.checked)"
                    @click="onOk"
                />
            </div>
        </template>
    </BaseModal>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from '🔗/components/ui/Button.vue';
import AdditionFields from '🔗/components/ui/AdditionFields.vue';
import Message from '🔗/components/ui/Message.vue';
import BaseModal from '🔗/components/modals/BaseModal.vue';

import { storeToRefs } from 'pinia';
import stores from '@/stores';

const modals = stores.modals();
const { confirmSettings } = storeToRefs(modals);

const { t } = useI18n();

const additionFields = ref(null);

const props = defineProps({
    closeOutside: {
        type: Boolean,
        default: true
    },
    name: {
        type: String,
        default: 'confirm'
    }
});

const reset = () => {
    modals.resetConfirm();
};

const onCancel = () => {
    if (confirmSettings.value.onCancel) {
        confirmSettings.value.onCancel();
    }

    reset();
};

const onOk = () => {
    if (additionFields.value && !additionFields.value.validate()) {
        return;
    }

    if (confirmSettings.value.onOk) {
        confirmSettings.value.onOk({
            additionFields: confirmSettings.value.additionFields
        });
    }

    if (!confirmSettings.value?.cancelReset) {
        reset();
    }
};
</script>

<style lang="scss">
    .modal-confirm {
        max-width: 420px;
    }
</style>

<style lang="scss" scoped>
.title {
    font: var(--font-h5);
    text-align: start;
    font-weight: bold;
    color: var(--dark-500);
}

.modal-confirm-body {
    display: flex;
    flex-direction: column;
    
    gap: 20px;

    .question {
        font: var(--font-body-1);
        color: var(--dark-500);
        text-align: start;
        word-wrap: break-word;
        // gap: 8px;
        display: block;
        // flex-direction: row;
        // flex-wrap: wrap;
        // margin: 0 auto;
        b {
            font-weight: bold;
        }
    }

    .confirmations {
        display: flex;
        flex-direction: column;
        list-style: none;
        padding: 0;
        margin: 0;
        gap: 8px;
        li {
            @include checkbox();
        }
    }    
}

.buttons {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    justify-content: end;
}
</style>
